import React from 'react';
import Icon from '../../../components/AppIcon';

const AuditStatisticsCard = ({ statistics, loading }) => {
  if (loading) {
    return (
      <div className="bg-card border border-border rounded-lg p-4 md:p-6">
        <div className="animate-pulse space-y-4">
          <div className="h-6 bg-muted rounded w-1/3"></div>
          <div className="h-20 bg-muted rounded"></div>
        </div>
      </div>
    );
  }

  const topPerformers = Object.entries(statistics?.topPerformers || {})?.sort((a, b) => b?.[1] - a?.[1])?.slice(0, 5);

  const sourceData = Object.entries(statistics?.bySource || {});
  const actionTypeData = Object.entries(statistics?.byActionType || {})?.slice(0, 5);

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="BarChart3" size={20} color="var(--color-primary)" />
          <h3 className="font-heading font-semibold text-base md:text-lg text-foreground">
            Audit Statistics
          </h3>
        </div>
      </div>
      <div className="p-4 md:p-6 space-y-6">
        {/* Total Actions */}
        <div className="bg-muted rounded-lg p-4">
          <p className="caption text-xs text-muted-foreground mb-1">Total Actions</p>
          <p className="text-2xl font-bold text-foreground">
            {statistics?.totalActions?.toLocaleString('en-PG') || 0}
          </p>
        </div>

        {/* By Source */}
        <div>
          <h4 className="caption text-sm font-medium text-foreground mb-3">By Source</h4>
          <div className="space-y-2">
            {sourceData?.map(([source, count]) => (
              <div key={source} className="flex items-center justify-between">
                <span className="caption text-xs text-muted-foreground capitalize">
                  {source?.replace('_', ' ')}
                </span>
                <span className="caption text-sm font-medium text-foreground">{count}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Top Action Types */}
        <div>
          <h4 className="caption text-sm font-medium text-foreground mb-3">Top Action Types</h4>
          <div className="space-y-2">
            {actionTypeData?.map(([action, count]) => (
              <div key={action} className="flex items-center justify-between">
                <span className="caption text-xs text-muted-foreground">{action}</span>
                <span className="caption text-sm font-medium text-foreground">{count}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Top Performers */}
        <div>
          <h4 className="caption text-sm font-medium text-foreground mb-3">Top Performers</h4>
          <div className="space-y-2">
            {topPerformers?.map(([performer, count]) => (
              <div key={performer} className="flex items-center justify-between">
                <span className="caption text-xs text-muted-foreground truncate max-w-[200px]">
                  {performer}
                </span>
                <span className="caption text-sm font-medium text-foreground">{count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditStatisticsCard;